module.exports = __webpack_public_path__ + "static/img/cgk.3a2c32b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/cgk.png
// module id = UIBH
// module chunks = 1